module.exports = __webpack_public_path__ + "r-v3/img/sticker_4.cc200980.svg";